import { StatementDataViewContext } from "@bToC/Store/Data/Statements/StatementSelector";
import updateSearchFields from "@bToC/Store/Pages/Statements/Handlers/UpdateSearchFields";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import React, { FC, useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps>;

export interface StatementPaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const paginationStyles: StatementPaginationStyles = {
    pagination: {
        cssOverrides: {
            pagination: css`
                @media print {
                    display: none !important;
                }
            `,
         }
    },
};

const styles = paginationStyles;

const StatementPagination: FC<Props> = ({ updateSearchFields }) => {
    const statementDataView = useContext(StatementDataViewContext);
    const changePage = (newPageIndex: number) => {
        updateSearchFields({
            page: newPageIndex,
        });
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        updateSearchFields({
            page: 1,
            pageSize: newPageSize,
        });
    };

    if (!statementDataView.value) {
        return null;
    }

    const { pagination } = statementDataView;
    if (!pagination || pagination.totalItemCount === 0) {
        return null;
    }

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={pagination.totalItemCount}
            currentPage={pagination.page}
            resultsPerPage={pagination.pageSize}
            resultsPerPageOptions={pagination.pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            pageSizeCookie="Statements-PageSize"
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(StatementPagination),
    definition: {
        group: "Basic",
        displayName: "Statements Pagination",
    },
};

export default widgetModule;
